import { IconProps as ChakraIconProps } from '@chakra-ui/react'
import { Ref } from 'react'

import { IconTypes, iconRegistry } from './icon-registry'

export interface IconProps extends ChakraIconProps {
  icon: IconTypes
  ref?: Ref<SVGSVGElement>
}

export const Icon = ({ icon, ref, ...props }: IconProps) => {
  const FoundIcon = iconRegistry[icon]

  if (!FoundIcon) {
    console.error(`Icon ${icon} not found in icon registry.`)
    return null
  }

  return <FoundIcon ref={ref} {...props} />
}
